import { Badge } from '@/components/ui/badge'
import { formatPercent } from '@/utils/format'

export interface MatchRateBadgeProps {
  /** A percentage, not a fraction — 12.5 means 12.5% of requests. */
  value: number
}

/**
 * How much of the network's traffic a keyword or category is seen on. The
 * thresholds are the ad server's own: half the traffic or more reads as broad,
 * a fifth or more as usable, anything below that as narrow.
 */
export function MatchRateBadge({ value }: MatchRateBadgeProps) {
  const variant = value >= 50 ? 'success' : value >= 20 ? 'blue' : 'gray'
  // Below a hundredth of a percent the exact figure says nothing useful.
  const label = value < 0.01 ? '< 0.01%' : formatPercent(value, value < 1 ? 2 : 1)

  return (
    <Badge variant={variant} className="shrink-0 font-normal tabular-nums">
      {label}
    </Badge>
  )
}
